import { render, staticRenderFns } from "./SidebarInfo.vue?vue&type=template&id=9ebb1e8e&scoped=true&"
import script from "./SidebarInfo.vue?vue&type=script&lang=js&"
export * from "./SidebarInfo.vue?vue&type=script&lang=js&"
import style0 from "./SidebarInfo.vue?vue&type=style&index=0&id=9ebb1e8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ebb1e8e",
  null
  
)

export default component.exports